import { useTranslation } from "react-i18next";

import MenuLink from "../partials/MenuLink";

import { doProxyLoginReverse } from "./ProxyLoginReverseMutation";

const ProxyLoginReverseMenuLink = props => {
  const { t } = useTranslation();
  return (
    <MenuLink
      bg="nav.95"
      onClick={() => doProxyLoginReverse()}
      onKeyDown={event => {
        if (event.key === "Enter") {
          doProxyLoginReverse();
          event.preventDefault();
        }
      }}
    >
      {t("nav.primary.myAccount.proxyLoginReverse")}
    </MenuLink>
  );
};

export default ProxyLoginReverseMenuLink;
